import script from "./ChatSuggestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSuggestions.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSuggestions.vue?vue&type=style&index=0&id=3dbcac7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbcac7c"]])

export default __exports__